import React, { Component } from 'react';

import SolicitarBaja from './SolicitarBaja';
import BajaCuentaConfirmada from './BajaCuentaConfirmada';

class BajaCuentaPrepaga extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        this.props.actions.dataInicial();
    }

    render() {
        const {data,tarjetas} = this.props;
        let titulo = <div></div>;
        let componente = null;
        debugger
        switch(tarjetas.cuentaCorriente.cuentaTarjetaEstadoId){
            case 3:{ //CUENTA OPERATIVA, SE MUESTRA LA PANTALLA PARA DARLA DE BAJA
                titulo = <div><h2 className='bottom-separator bottom-padding-xxs'>Baja de cuenta</h2> </div>;
                componente = <SolicitarBaja actions={this.props.actions} data={data} cuenta={tarjetas.cuentaCorriente} />;
                break;
            }
            case 6:{ //CUENTA DADA DE BAJA, SE MUESTRA LA PANTALLA CON LOS DATOS DE LA BAJA
                titulo = <div><h2 className='bottom-separator bottom-padding-xxs'>Cuenta dada de baja</h2> </div>;
                componente = <BajaCuentaConfirmada cuenta={tarjetas.cuentaCorriente} data={data}/>;
                break;
            }
            case 20:{ //ESTADO QUE NO EXISTE EN BASE, SE LE ASIGNA EN EL FRONT A LA CUENTA CON LA ACTION QUE DA LA BAJA PARA MOSTRAR ESTA PANTALLA DE BAJA CONFIRMADA POR ÚNICA VEZ
            titulo = <div className='bottom-separator bottom-padding-xxs'>
                        <h2>Confirmación de Baja de Cuenta</h2> 
                        <div className='infoCuentaBajaTitulo'>{ tarjetas.Cliente.Nombre + " " + tarjetas.Cliente.Apellido + " - " + tarjetas.cuentaCorriente.CuentaEntidadNumero}</div> 
                    </div>;
                componente = <BajaCuentaConfirmada esConfirmacion={true} data={data}/>;
                break;
            }
        }

        return (  
        <div className="container-fluid">
            <div className='contenedorDatosIntegranteIndividualCuenta'>
                {titulo}
            </div>
            {componente}
        </div>);
    }
}
 
export default BajaCuentaPrepaga;